"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDERED_LIST_ITEM = exports.UNORDERED_LIST_ITEM = exports.CHECKABLE_LIST_ITEM = void 0;
var CHECKABLE_LIST_ITEM = 'checkable-list-item'; // https://github.com/facebook/draft-js/blob/master/src/model/constants/DraftBlockType.js#L27-L28

exports.CHECKABLE_LIST_ITEM = CHECKABLE_LIST_ITEM;
var UNORDERED_LIST_ITEM = 'unordered-list-item';
exports.UNORDERED_LIST_ITEM = UNORDERED_LIST_ITEM;
var ORDERED_LIST_ITEM = 'ordered-list-item';
exports.ORDERED_LIST_ITEM = ORDERED_LIST_ITEM;